/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface GetAdminRelationshipConfigurationRequest {
    sessionId?: string;
}

export interface GetConfigurationChangeImpactRequest {
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

export interface GetTenantAdminRelationshipConfigurationRequest {
    tenantId: string;
    sessionId?: string;
}

export interface UpdateAdminRelationshipConfigurationRequest {
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

export interface UpdateTenantAdminRelationshipConfigurationRequest {
    tenantId: string;
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

export interface ValidateAdminRelationshipConfigurationRequest {
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

/**
 * AdminRelationshipConfigurationApi - interface
 * 
 * @export
 * @interface AdminRelationshipConfigurationApiInterface
 */
export interface AdminRelationshipConfigurationApiInterface {
    /**
     * Retrieve current admin relationship configuration
     * @summary Get admin relationship configuration
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRelationshipConfigurationApiInterface
     */
    getAdminRelationshipConfigurationRaw(requestParameters: GetAdminRelationshipConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieve current admin relationship configuration
     * Get admin relationship configuration
     */
    getAdminRelationshipConfiguration(requestParameters: GetAdminRelationshipConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Analyze the impact of proposed configuration changes
     * @summary Get configuration change impact
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRelationshipConfigurationApiInterface
     */
    getConfigurationChangeImpactRaw(requestParameters: GetConfigurationChangeImpactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Analyze the impact of proposed configuration changes
     * Get configuration change impact
     */
    getConfigurationChangeImpact(requestParameters: GetConfigurationChangeImpactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieve admin relationship configuration for a specific tenant
     * @summary Get tenant admin relationship configuration
     * @param {string} tenantId Tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRelationshipConfigurationApiInterface
     */
    getTenantAdminRelationshipConfigurationRaw(requestParameters: GetTenantAdminRelationshipConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieve admin relationship configuration for a specific tenant
     * Get tenant admin relationship configuration
     */
    getTenantAdminRelationshipConfiguration(requestParameters: GetTenantAdminRelationshipConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Update system-wide admin relationship configuration
     * @summary Update admin relationship configuration
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRelationshipConfigurationApiInterface
     */
    updateAdminRelationshipConfigurationRaw(requestParameters: UpdateAdminRelationshipConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Update system-wide admin relationship configuration
     * Update admin relationship configuration
     */
    updateAdminRelationshipConfiguration(requestParameters: UpdateAdminRelationshipConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Update tenant-specific admin relationship configuration
     * @summary Update tenant admin relationship configuration
     * @param {string} tenantId Tenant ID
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRelationshipConfigurationApiInterface
     */
    updateTenantAdminRelationshipConfigurationRaw(requestParameters: UpdateTenantAdminRelationshipConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Update tenant-specific admin relationship configuration
     * Update tenant admin relationship configuration
     */
    updateTenantAdminRelationshipConfiguration(requestParameters: UpdateTenantAdminRelationshipConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Validate admin relationship configuration without applying changes
     * @summary Validate admin relationship configuration
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRelationshipConfigurationApiInterface
     */
    validateAdminRelationshipConfigurationRaw(requestParameters: ValidateAdminRelationshipConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Validate admin relationship configuration without applying changes
     * Validate admin relationship configuration
     */
    validateAdminRelationshipConfiguration(requestParameters: ValidateAdminRelationshipConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class AdminRelationshipConfigurationApi extends runtime.BaseAPI implements AdminRelationshipConfigurationApiInterface {

    /**
     * Retrieve current admin relationship configuration
     * Get admin relationship configuration
     */
    async getAdminRelationshipConfigurationRaw(requestParameters: GetAdminRelationshipConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin-relationship-config`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieve current admin relationship configuration
     * Get admin relationship configuration
     */
    async getAdminRelationshipConfiguration(requestParameters: GetAdminRelationshipConfigurationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getAdminRelationshipConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Analyze the impact of proposed configuration changes
     * Get configuration change impact
     */
    async getConfigurationChangeImpactRaw(requestParameters: GetConfigurationChangeImpactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling getConfigurationChangeImpact().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/admin-relationship-config/impact`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Analyze the impact of proposed configuration changes
     * Get configuration change impact
     */
    async getConfigurationChangeImpact(requestParameters: GetConfigurationChangeImpactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getConfigurationChangeImpactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve admin relationship configuration for a specific tenant
     * Get tenant admin relationship configuration
     */
    async getTenantAdminRelationshipConfigurationRaw(requestParameters: GetTenantAdminRelationshipConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getTenantAdminRelationshipConfiguration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin-relationship-config/tenant/{tenantId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieve admin relationship configuration for a specific tenant
     * Get tenant admin relationship configuration
     */
    async getTenantAdminRelationshipConfiguration(requestParameters: GetTenantAdminRelationshipConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getTenantAdminRelationshipConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update system-wide admin relationship configuration
     * Update admin relationship configuration
     */
    async updateAdminRelationshipConfigurationRaw(requestParameters: UpdateAdminRelationshipConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling updateAdminRelationshipConfiguration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/admin-relationship-config`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Update system-wide admin relationship configuration
     * Update admin relationship configuration
     */
    async updateAdminRelationshipConfiguration(requestParameters: UpdateAdminRelationshipConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateAdminRelationshipConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update tenant-specific admin relationship configuration
     * Update tenant admin relationship configuration
     */
    async updateTenantAdminRelationshipConfigurationRaw(requestParameters: UpdateTenantAdminRelationshipConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateTenantAdminRelationshipConfiguration().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling updateTenantAdminRelationshipConfiguration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/admin-relationship-config/tenant/{tenantId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Update tenant-specific admin relationship configuration
     * Update tenant admin relationship configuration
     */
    async updateTenantAdminRelationshipConfiguration(requestParameters: UpdateTenantAdminRelationshipConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateTenantAdminRelationshipConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate admin relationship configuration without applying changes
     * Validate admin relationship configuration
     */
    async validateAdminRelationshipConfigurationRaw(requestParameters: ValidateAdminRelationshipConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling validateAdminRelationshipConfiguration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/admin-relationship-config/validate`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Validate admin relationship configuration without applying changes
     * Validate admin relationship configuration
     */
    async validateAdminRelationshipConfiguration(requestParameters: ValidateAdminRelationshipConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.validateAdminRelationshipConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
